import { useState, Dispatch, SetStateAction, Ref, useImperativeHandle } from 'react';
import { FilterState } from '../FiltersArea';
import OptionsRangeFilter from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter';
import { Resettable } from '@/models/Resettable';

interface TransactionTypeOption {
  id: string;
  label: string;
  checked: boolean;
  transactionKinds: string[];
}

interface TransactionTypeFilterProps {
  setFilterState: Dispatch<SetStateAction<FilterState>>;
  ref?: Ref<Resettable>;
}

const TransactionTypeFilter = ({ setFilterState, ref }: TransactionTypeFilterProps) => {
  const [options, setOptions] = useState<TransactionTypeOption[]>([
    {
      id: 'donation',
      label: 'donation',
      checked: false,
      transactionKinds: ['תרומה'],
    },
    {
      id: 'support',
      label: 'support',
      checked: false,
      transactionKinds: ['תמיכה', 'מלגה'],
    },
    {
      id: 'payment',
      label: 'payment',
      checked: false,
      transactionKinds: ['תשלום', 'תשלום ספקים', 'תשלום ספקים (הוראת קבע)'],
    },
  ]);

  const handleOptionChange = (optionId: string) => {
    const updatedOptions = options.map((option) => (option.id === optionId ? { ...option, checked: !option.checked } : option));
    setOptions(updatedOptions);

    const selectedValues = updatedOptions.filter((option) => option.checked).flatMap((option) => option.transactionKinds);

    setFilterState((prev) => ({
      ...prev,
      kinds: selectedValues,
    }));
  };

  const handleSelectAllChange = (selectAll: boolean) => {
    const updatedOptions = options.map((option) => ({ ...option, checked: selectAll }));
    setOptions(updatedOptions);

    const selectedValues = selectAll ? updatedOptions.flatMap((option) => option.transactionKinds) : [];

    setFilterState((prev) => ({
      ...prev,
      kinds: selectedValues,
    }));
  };

  useImperativeHandle(ref, () => ({
    reset: () => {
      setOptions((prevOptions) => prevOptions.map((option) => ({ ...option, checked: false })));
    },
  }));

  return (
    <OptionsRangeFilter
      title="transactionType"
      filterType="options"
      options={options.map(({ id, label, checked }) => ({ id, label, checked }))}
      onOptionChange={handleOptionChange}
      onSelectAllChange={handleSelectAllChange}
      selectionType="checkbox"
    />
  );
};

export default TransactionTypeFilter;
